import * as Phaser from "phaser-ce"
import { PhaserUtils } from "../../utils/PhaserUtils"

export enum TmAudio {
    CHEW_ESOPHAGUS_1 = "time-machine-chew-esophagus-n1.mp3",
    CHEW_ESOPHAGUS_2 = "time-machine-chew-esophagus-n2.mp3",
    CHEW_ESOPHAGUS_3 = "time-machine-chew-esophagus-n3.mp3",
    CHEW_ESOPHAGUS_4 = "time-machine-chew-esophagus-n4.mp3",
    CHEW_MOUTH_1 = "time-machine-chew-mouth-n1.mp3",
    CHEW_MOUTH_2 = "time-machine-chew-mouth-n2.mp3",
    CHEW_MOUTH_3 = "time-machine-chew-mouth-n3.mp3",
    CHEW_MOUTH_4 = "time-machine-chew-mouth-n4.mp3",
    CHEW_1 = "time-machine-chew-n1.mp3",
    CHEW_2 = "time-machine-chew-n2.mp3",
    CHEW_OUTRO = "time-machine-chew-outro-n1.mp3",
    CHEW_STOMACH_1 = "time-machine-chew-stomach-n1.mp3",
    CHEW_STOMACH_2 = "time-machine-chew-stomach-n2.mp3",
    CHEW_STOMACH_3 = "time-machine-chew-stomach-n3.mp3",
    CHEW_STOMACH_4 = "time-machine-chew-stomach-n4.mp3",

    ONE = "time-machine-n1.mp3",
    TWO = "time-machine-n2.mp3",
    THREE = "time-machine-n3.mp3",

    CHEW_DONE = "time-machine-outro-chew-done.mp3",
    CHEWING_OUTRO = "time-machine-outro-chewing.mp3",
    CHEWING_SMOKING = "time-machine-outro-chewing-smoking.mp3",
    CHEWING_VAPING = "time-machine-outro-chewing-vaping.mp3",
    SMOKING_OUTRO = "time-machine-outro-smoking.mp3",
    SMOKING_DONE = "time-machine-outro-smoking-done.mp3",
    SMOKING_VAPING = "time-machine-outro-smoking-vaping.mp3",
    VAPING_OUTRO = "time-machine-outro-vaping.mp3",
    VAPING_DONE = "time-machine-outro-vaping-done.mp3",

    SMOKING_HEART_1 = "time-machine-smoking-heart-n1.mp3",
    SMOKING_HEART_2 = "time-machine-smoking-heart-n2.mp3",
    SMOKING_HEART_3 = "time-machine-smoking-heart-n3.mp3",
    SMOKING_HEART_4 = "time-machine-smoking-heart-n4.mp3",
    SMOKING_LUNGS_1 = "time-machine-smoking-lungs-n1.mp3",
    SMOKING_LUNGS_2 = "time-machine-smoking-lungs-n2.mp3",
    SMOKING_LUNGS_3 = "time-machine-smoking-lungs-n3.mp3",
    SMOKING_LUNGS_4 = "time-machine-smoking-lungs-n4.mp3",
    SMOKING_MOUTH_1 = "time-machine-smoking-mouth-n1.mp3",
    SMOKING_MOUTH_2 = "time-machine-smoking-mouth-n2.mp3",
    SMOKING_MOUTH_3 = "time-machine-smoking-mouth-n3.mp3",
    SMOKING_MOUTH_4 = "time-machine-smoking-mouth-n4.mp3",
    SMOKING_1 = "time-machine-smoking-n1.mp3",
    SMOKING_2 = "time-machine-smoking-n2.mp3",
    SMOKING_OUTRO_1 = "time-machine-smoking-outro-n1.mp3",

    VAPING_HEART_1 = "time-machine-vaping-heart-n1.mp3",
    VAPING_HEART_2 = "time-machine-vaping-heart-n2.mp3",
    VAPING_HEART_3 = "time-machine-vaping-heart-n3.mp3",
    VAPING_HEART_4 = "time-machine-vaping-heart-n4.mp3",
    VAPING_LUNGS_1 = "time-machine-vaping-lungs-n1.mp3",
    VAPING_LUNGS_2 = "time-machine-vaping-lungs-n2.mp3",
    VAPING_LUNGS_3 = "time-machine-vaping-lungs-n3.mp3",
    VAPING_LUNGS_4 = "time-machine-vaping-lungs-n4.mp3",
    VAPING_MOUTH_1 = "time-machine-vaping-mouth-n1.mp3",
    VAPING_MOUTH_2 = "time-machine-vaping-mouth-n2.mp3",
    VAPING_MOUTH_3 = "time-machine-vaping-mouth-n3.mp3",
    VAPING_MOUTH_4 = "time-machine-vaping-mouth-n4.mp3",
    VAPING_1 = "time-machine-vaping-n1.mp3",
    VAPING_2 = "time-machine-vaping-n2.mp3",
    VAPING_OUTRO_1 = "time-machine-vaping-outro-n1.mp3",

    SCAN_SOUND = "scan-sound.mp3",
    FORWARD_BEEP = "forward-beep.mp3",
    POWER_UP = "power-up.mp3",
    POWER_DOWN = "power-down.mp3"
}

export enum TmImage {
    BACKGROUND = "background.png",
    VIDEO_BACKGROUND = "video-background.png",
    EMPTY_BODY = "empty-body.png",
    ESOPHAGUS = "esophagus.png",
    HEART = "heart.png",
    LUNGS = "lungs.png",
    MOUTH = "mouth.png",
    STOMACH = "stomach.png",
    MOUTH_WINDOW = "mouth-window.png",
    ESOPHAGUS_WINDOW = "esophagus-window.png",
    STOMACH_WINDOW = "stomach-window.png",
    LUNGS_WINDOW = "lungs-window.png",
    HEART_WINDOW = "heart-window.png",
}

export enum TmSprite {
    DASHBOARD_BUTTON = "TimeMachineDASHBOARD_BUTTON",
    ARROW = "TimeMachineARROW",
    TIME_BAR = "TimeMachineTIME_BAR",
    CLOSE_BUTTON = "TimeMachineCLOSE_BUTTON",
}

export enum TmAtlas {
    SCAN_SMOKER = "scan-smoker.json",
    SCAN_CHEWER = "scan-chewer.json",
    SCAN_VAPER = "scan-vaper.json",
    ESOPHAGUS_CHEW_EFFECTS = "esophagus-chew-effects.json",
    MOUTH_CHEW_EFFECTS = "mouth-chew-effects.json",
    STOMACH_CHEW_EFFECTS = "stomach-chew-effects.json",
    MOUTH_SMOKING_EFFECTS = "mouth-smoking-effects.json",
    HEART_SMOKING_CHEW_EFFECTS = "heart-smoking-effects.json",
    LUNGS_SMOKING_EFFECTS = "lungs-smoking-effects.json",
    MOUTH_VAPING_EFFECTS = "mouth-vaping-effects.json",
    LUNG_VAPING_EFFECTS = "lungs-vaping-effects.json",
    HEART_VAPING_EFFECTS = "heart-vaping-effects.json"
}

export enum TmVideo {
    CHEWER_VIDEO = "chewer.mp4",
    SMOKER_VIDEO = "smoker.mp4",
    VAPER_VIDEO = "vaper.mp4",
    MATRIX_VIDEO = "matrix.mp4"
}

export function loadAssets(game: Phaser.Game) {

    const load = PhaserUtils.makeLoader(game, "time-machine")
    
    load.autoLoad({imageEnum: TmImage, audioEnum: TmAudio, atlasEnum: TmAtlas, videoEnum: TmVideo})

    load.spritesheet(TmSprite.DASHBOARD_BUTTON, "dashboard-button.png", 165, 54)
    load.spritesheet(TmSprite.ARROW, "arrow.png", 36, 46)
    load.spritesheet(TmSprite.TIME_BAR, "time-bar.png", 304, 14)
    load.spritesheet(TmSprite.CLOSE_BUTTON, "close-button.png", 128, 21)
}

export enum TimeMachineColor {
    LIGHT = "#7a7eaf",
}
